import React from 'react';
import { I18n } from '@fiverr-private/fiverr_context';

const TranslatedResult = ({ query, searchInsteadUrl, modifiedQueryString, phraseStart }) => (
    <React.Fragment>
        <I18n k="search_perseus.search_results_counter.showing_results" params={{ phraseStart }}/>&nbsp;
        <span>{modifiedQueryString}</span>.
        <div>
            <I18n k="search_perseus.search_results_counter.search_instead"/>&nbsp;
            <a href={searchInsteadUrl}>{query}</a>
        </div>
    </React.Fragment>
);

export default TranslatedResult;
